import styled from 'styled-components';

export const SForgotPassword = styled.div`
  color: ${({ theme }) => theme.colors.primaryText};
  font-size: 12.5px;
  margin-bottom: 90px;
  margin-top: 20px;
  text-decoration: underline;
  width: 105px;
`;

export const SLink = styled.span`
  font-weight: 500;
  cursor: pointer;
  color: ${({ theme }) => theme.colors.primaryText};

  &:hover {
    text-decoration: underline;
  }
`;

export const SInfo = styled.div`
  color: ${({ theme }) => theme.colors.secondaryText};
  font-size: 12.5px;
  white-space: nowrap;
`;

export const SInfoMed = styled.div`
  white-space: nowrap;

  font-size: 15px;
  color: ${({ theme }) => theme.colors.secondaryText};
`;

export const SInfoLarge = styled.div`
  white-space: nowrap;

  font-size: 20px;
  color: ${({ theme }) => theme.colors.secondaryText};
`;
